// app/src/pages/ProSignUpPage.tsx
import React, { FC, useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useScaleDesktop } from '../contexts/ScaleContextDesktop';
import HeaderResponsivePart from '../components/responsive/HeaderResponsivePart';
import { useAuthContext } from '../contexts/AuthContext';
import { CircularProgress } from "@mui/material";
import SignUpPageDesktopPart
	from "../components/desktop/part/SignUpPageDesktopPart";
import SignUpPageMobilePart
	from "../components/mobile/part/SignUpPageMobilePart";
import { emitAnalytics, getTelemetryDeviceType } from '../services/telemetry/appInsights';
import { useTranslation } from 'react-i18next';


const PartSignUpPage: FC = () => {
	const { i18n } = useTranslation();
	const { loadingSignup } = useAuthContext();
	const {scaleDesktop} = useScaleDesktop();
	const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
	const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });
	const hasTrackedSignupStart = useRef(false);

	useEffect(() => {
		if (hasTrackedSignupStart.current) {
			return;
		}

		hasTrackedSignupStart.current = true;
		emitAnalytics('part_signup_started', {
			entryRoute: '/part/signup',
			deviceType: getTelemetryDeviceType(),
			language: i18n.language,
		});
	}, []);
	
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'start',
				alignItems: 'center',
			}}
		>
			<HeaderResponsivePart/>

			{loadingSignup &&
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						transform: `scale(${scaleDesktop})`,
						transformOrigin: 'top',
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(255, 255, 255, 0.8)',
						backdropFilter: 'blur(3px)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 10,
					}}
				>
					<CircularProgress />
				</div>
			}
			{isDesktop ? (
				<div
					style={{
						position: 'absolute',
						top: 90,
						transform: `scale(${scaleDesktop})`,
						color: '#323E48',
						transformOrigin: 'top',
						transition: 'transform 0.3s ease, padding 0.3s ease',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center'
					}}
				>
					<SignUpPageDesktopPart />
				</div>
			) : (
				<>
					<SignUpPageMobilePart />
				</>
			)}
		</div>
	);
};

export default PartSignUpPage;
